import * as React from 'react';
import { Form, Formik } from 'formik';
import {
  ReportActions,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';

export interface TournamentReportOption {
  field: string;
  label: string;
  hint: string;
  initialValue: boolean;
}

interface Props {
  description: React.ReactNode;
  reportType: string;
  options: TournamentReportOption[];
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  sectionTitle?: string;
  sectionHint?: string;
}

export function TournamentReportOptionsForm({
  description,
  reportType,
  options,
  onCloseClick,
  onSubmit,
  sectionTitle = 'Report content',
  sectionHint = 'Choose the information included in the generated report.'
}: Props) {
  const initialValues = options.reduce(
    (values, option) => ({ ...values, [option.field]: option.initialValue }),
    {} as Record<string, boolean>
  );

  return (
    <Formik initialValues={initialValues} onSubmit={values => onSubmit(values, reportType)}>
      {({ values, setFieldValue }) => (
        <Form className="eReportForm unionTournamentReportForm">
          <div className="eReportForm__content">
            <ReportDescription>{description}</ReportDescription>
            <ReportSection number={1} title={sectionTitle} hint={sectionHint}>
              <ReportToggleList>
                {options.map(option => (
                  <ReportToggle
                    key={option.field}
                    name={option.field}
                    label={option.label}
                    hint={option.hint}
                    value={Boolean(values[option.field])}
                    onChange={value => setFieldValue(option.field, value)}
                  />
                ))}
              </ReportToggleList>
            </ReportSection>
          </div>
          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
